import React, { useRef } from 'react';
import PropTypes         from 'prop-types';
import Slider            from "react-slick";
import classNames        from 'classnames';

import useCarousel       from './useCarousel';

import Icons             from '../../../assets/svg/icons.js';

import styles            from './Carousel.styl';

const SLIDES = [
    {
        number: '1',
        title: 'Create an account',
        description: 'It will take 2 minutes. No credit card required.'
    },
    {
        number: '2',
        title: 'Connect Apps, MMP',
        description: 'Several links and ID\'s are needed and you are ready to go.'
    },
    {
        number: '3',
        title: 'Create Rules',
        description: 'Let\'s automate it.'
    },
    {
        number: '4',
        title: 'Run Simulations',
        description: 'Preview changes in a safe mode.'
    },
    {
        number: '5',
        title: 'Automation is Ready!',
        description: 'Iterate, iterate, iterate: the key to success.'
    },
]

export const CAROUSEL_SETTINGS = {
    defaultSlidesToShow : 3,
    lSizeSlidesToshow   : 2,
    mSizeSlidesToshow   : 2,
    sSizeSlidesToshow   : 1
};
function Carousel(props) {
    const {
        className
    } = props;

    const sliderRef = useRef()

    const {
        // handleNext,
        // handlePrev,
        handleAfterChange
    } = useCarousel(sliderRef);

    function SampleNextArrow(props) {
        const { className, style, onClick } = props; // eslint-disable-line
        
        return (
            <div
                className = {classNames(styles.button, styles.nextButton)}
                onClick   = {onClick}
                // style     = {style}
            >
                <Icons.ArrowNormal />
            </div>
        );
    }
      
    function SamplePrevArrow(props) {
        const { className, style, onClick } = props; // eslint-disable-line

        return (
            <div
                className = {classNames(styles.button, styles.prevButton)}
                onClick   = {onClick}
                // style     = {style}
            >
                <Icons.ArrowNormal
                    className={styles.prevIcon}
                />
            </div>
        );
    }

    const settings = {
        speed        : 500,
        infinite     : false,
        // arrows       : false,
        slidesToShow : CAROUSEL_SETTINGS.defaultSlidesToShow,
        draggable    : true,
        swipeToSlide : true,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        afterChange  : current => handleAfterChange(current),
        responsive   : [
            {
                breakpoint : 1025,
                settings   : {
                    slidesToShow : CAROUSEL_SETTINGS.lSizeSlidesToshow,
                    centerMode   : false,
                    afterChange  : current => handleAfterChange(current, CAROUSEL_SETTINGS.lSizeSlidesToshow)
                }
            },
            {
                breakpoint : 960,
                settings   : {
                    slidesToShow : CAROUSEL_SETTINGS.mSizeSlidesToshow,
                    centerMode   : false,
                    afterChange  : current => handleAfterChange(current, CAROUSEL_SETTINGS.mSizeSlidesToshow)
                }
            },
            {
                breakpoint : 600,
                settings   : {
                    slidesToShow   : CAROUSEL_SETTINGS.sSizeSlidesToshow,
                    slidesToScroll : CAROUSEL_SETTINGS.sSizeSlidesToshow,
                    centerMode     : false,
                    afterChange    : current => handleAfterChange(current, CAROUSEL_SETTINGS.sSizeSlidesToshow)
                }
            }
        ]
    };

    return  (
        <div
            className={classNames(styles.Carousel, className)}
        >
            <Slider
                {...settings}
                className = {styles.carousel}
                ref       = {sliderRef}
            >
                {SLIDES.map(item => (
                    <div
                        key       = {item.number}
                        className = {styles.slideBlock}
                    >
                        <div className={styles.wrapper}>
                            <div className={styles.number}>
                                {item.number}
                            </div>
                            <div className={styles.textWrapper}>
                                <div className={styles.cardTitle}>
                                    {item.title}
                                </div>
                                <div className={styles.cardDescription}>
                                    {item.description}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
            {/* <div className={styles.buttons}>
                <div
                    className = {classNames(styles.button, styles.prevButton)}
                    onClick   = {handlePrev}
                >
                    <Icons.ArrowNormal
                        className={styles.prevIcon}
                    />
                </div>
                <div
                    className = {classNames(styles.button, styles.nextButton)}
                    onClick   = {handleNext}
                >
                    <Icons.ArrowNormal />
                </div>
            </div> */}
        </div>
    );
}

Carousel.propTypes = {
    className : PropTypes.string
};

Carousel.defaultProps = {
    className : ''
};

export default Carousel;
